'use client';

import { ICaseInfo } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './Case.module.scss';
import Img from '../../../components/Img';
import { Theme, theme } from '../../../store/theme';

const CaseHero = ({ data }: { data: ICaseInfo }) => {
  const appTheme = useAtomValue(theme);

  const mainLogo = appTheme === Theme.LIGHT ? data.logoLight : data.logoDark;
  const altLogo = appTheme === Theme.LIGHT ? data.logoDark : data.logoLight;
  const logo = mainLogo || altLogo;

  const lightBgImage = data.lightImage || data.image;
  const darkBgImage = data.image || data.lightImage;
  const bgImage = appTheme === Theme.DARK ? darkBgImage : lightBgImage;

  const sectionStyles = bgImage ? { backgroundImage: `url(${bgImage.url})` } : {};

  return (
    <section
      className={styles.caseHero}
      style={sectionStyles}
    >
      <div className={classNames(styles.caseHeroContent, 'container')}>
        <Img
          src={logo?.url || ''}
          alt={logo?.alternativeText || 'case logo'}
          width={logo?.width}
          height={logo?.height}
          className={classNames(styles.caseLogo, {
            [styles.placeholder]: !logo,
          })}
        />
        <h1 className={styles.caseTitle}>{data.title}</h1>
        <div className={styles.caseStats}>
          {
            data.features.map(stat => (
              <div
                key={stat.title}
                className={styles.statItem}
              >
                <p className={styles.statTitle}>{stat.title}</p>
                <p className={styles.statValue}>{stat.description}</p>
              </div>
            ))
        }
        </div>
      </div>
    </section>
  );
};

export default CaseHero;
